var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.001C14.1217 7.001 16.1566 7.84385 17.6569 9.34415C19.1571 10.8444 20 12.8793 20 15.001C20 17.1227 19.1571 19.1576 17.6569 20.6579C16.1566 22.1581 14.1217 23.001 12 23.001C9.87827 23.001 7.84344 22.1581 6.34315 20.6579C4.84285 19.1576 4 17.1227 4 15.001C4 12.8793 4.84285 10.8444 6.34315 9.34415C7.84344 7.84385 9.87827 7.001 12 7.001ZM12 10.501L10.678 13.181L7.72 13.611L9.86 15.696L9.355 18.642L12 17.251L14.645 18.641L14.14 15.696L16.28 13.61L13.322 13.18L12 10.501ZM13 2L18 2.001V5.001L16.637 6.139C15.5062 5.54511 14.2712 5.17565 13 5.051V2ZM11 2V5.05C9.72918 5.17478 8.49449 5.54424 7.364 6.138L6 5.001V2.001L11 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalFill);
export default __webpack_public_path__ + "static/media/medal-fill.93d05608b11da35de962e618bec8cc19.svg";
export { ForwardRef as ReactComponent };